<template>
  <div class="card" v-if="loading">
    <div class="card-body">
      <div class="text-center">
        <b-spinner class="ms-2" variant="primary"></b-spinner>
        <p class="mt-2">Carregando filtros...</p>
      </div>
    </div>
  </div>

  <accordion v-else ref="accordionFiltroProjetosLote">
    <template #header="{ expandido }">
      <div
        class="col-md-6 col-sm-12 d-flex flex-column flex-md-row mb-2 mb-md-0 order-2 order-md-1 align-items-center"
      >
        <h4 class="font-size-16 mb-0" style="font-weight: 600">
          FILTRO DE PROJETOS DO LOTE N° {{ sqLote }}
        </h4>
      </div>

      <div
        class="col-md-6 col-sm-12 d-flex flex-column flex-md-row justify-content-md-end align-items-center order-1 order-md-2 mb-2 mb-md-0"
      >
        <i
          :class="expandido ? 'mdi mdi-filter' : 'mdi mdi-filter-outline'"
          class="icone-accordion"
        ></i>
      </div>
    </template>

    <div class="row d-flex mb-3">
      <!-- Status -->
      <div class="col-md-4">
        <b-form-group label="Status">
          <multiselect
            label="name"
            track-by="name"
            :max-height="150"
            selected-label=""
            placeholder="Selecione um status"
            v-model="selecaoStatusImportacaoVM"
            :options="selecaoStatusImportacaoLkp"
            deselect-label=""
            select-label=""
          >
            <span slot="noOptions">Nenhum status disponível</span>
            <span slot="noResult">Nenhum status encontrado</span>
          </multiselect>
        </b-form-group>
      </div>

      <!-- Projeto Unicampo -->
      <div class="col-md-4">
        <b-form-group label="Projeto Unicampo">
          <multiselect
            label="name"
            track-by="name"
            :max-height="150"
            v-model="selecaoProjetoVM"
            selected-label=""
            :options="selecaoProjetoLkp"
            placeholder="Selecione um projeto unicampo"
            deselect-label=""
            select-label=""
          >
            <span slot="noOptions">Nenhum projeto disponível</span>
            <span slot="noResult">Nenhum projeto encontrado</span>
          </multiselect>
        </b-form-group>
      </div>

      <!-- Linha de Crédito -->
      <div class="col-md-4">
        <b-form-group label="Linha de Crédito">
          <multiselect
            v-model="selecaoLinhaCreditoVM"
            :options="linhaCreditoLkp"
            label="name"
            track-by="name"
            placeholder="Selecione"
            select-label=""
            :max-height="200"
          >
            <span slot="noOptions">Nenhuma linha de crédito disponível</span>
            <span slot="noResult">Nenhuma linha de crédito encontrada</span>
          </multiselect>
        </b-form-group>
      </div>
    </div>

    <div class="row d-flex mb-3">
      <!-- Modalidade do Seguro -->
      <div class="col-md-6">
        <b-form-group label="Modalidade do Seguro">
          <multiselect
            label="name"
            track-by="name"
            :max-height="150"
            selected-label=""
            v-model="selecaoModalidadeSeguroVM"
            :options="selecaoModalidadeSeguroLkp"
            deselect-label=""
            select-label=""
            placeholder="Selecione uma modalidade de seguro"
          >
            <span slot="noResult">Nenhuma modalidade do seguro encontrada</span>
            <span slot="noOptions"
              >Nenhuma modalidade de seguro disponível</span
            >
          </multiselect>
        </b-form-group>
      </div>

      <!-- Safra -->
      <div class="col-md-6">
        <b-form-group label="Safra">
          <multiselect
            label="name"
            track-by="name"
            :max-height="200"
            v-model="selecaoSafraVM"
            :options="selecaoSafraLkp"
            selected-label=""
            placeholder="Selecione uma safra"
            deselect-label=""
            select-label=""
          >
            <span slot="noResult">Nenhuma safra encontrada</span>
            <span slot="noOptions">Nenhuma safra disponível</span>
          </multiselect>
        </b-form-group>
      </div>
    </div>

    <!-- Botões -->
    <div class="row py-2 position-relative row-buttons-filtro">
      <div
        class="col-md-6 col-sm-12 d-flex flex-column flex-md-row mb-2 mb-md-0 order-2 order-md-1 align-items-center gap-2"
      >
        <b-button
          @click="voltarAnterior"
          variant="secondary"
          size="md"
          class="mb-2 mb-md-0"
          data-tooltip="Voltar"
          data-tooltip-location="bottom"
        >
          <i class="mdi mdi-arrow-left-circle"></i>
          Voltar
        </b-button>

        <b-button
          @click="limpar"
          variant="secondary"
          class="mb-2 mb-md-0"
          data-tooltip="Limpar"
          data-tooltip-location="bottom"
        >
          <i class="mdi mdi-broom me-1"></i>
          <span>Limpar</span>
        </b-button>

        <b-button
          variant="primary"
          data-tooltip="Filtrar"
          @click="clicarParaFiltrar"
          :disabled="disabledFiltro"
          data-tooltip-location="bottom"
        >
          <i class="mdi mdi-filter-outline me-1"></i>
          <span>Filtrar</span>
          <b-spinner
            variant="secondary"
            small
            class="ms-2"
            v-if="disabledFiltro"
          ></b-spinner>
        </b-button>
      </div>
    </div>
  </accordion>
</template>

<script>
import Multiselect from "vue-multiselect";
import accordion from "@/components/accordion";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import {
  filtrosProjetosLoteHelper,
  paginacaoProjetoPorLoteHelper
} from "@/store/helpers/vuex/astec";

export default {
  mixins: [clienteRuralMixin],
  components: { Multiselect, accordion },

  props: {
    sqLote: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      loading: true,
      disabledFiltro: false,
      selecaoSafraLkp: [],
      linhaCreditoLkp: [],
      selecaoProjetoLkp: [],
      selecaoStatusImportacaoLkp: [
        { name: "INCOMPLETO [I]", value: "I" },
        { name: "COMPLETO [C]", value: "C" },
        { name: "EXPORTADO [E]", value: "E" }
      ],
      selecaoModalidadeSeguroLkp: [],
      filtroClicadoPeloBotao: false
    };
  },

  computed: {
    ...filtrosProjetosLoteHelper({
      state: [
        "selecaoStatusImportacao",
        "selecaoProjeto",
        "selecaoLinhaCredito",
        "selecaoModalidadeSeguro",
        "selecaoSafra"
      ],
      getters: ["filtroProjetosLote", "hasFiltrosAtivos"],
      actions: []
    }).computed,

    selecaoStatusImportacaoVM: {
      get() {
        return this.selecaoStatusImportacao;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoStatusImportacao", valor: val });
      }
    },

    selecaoProjetoVM: {
      get() {
        return this.selecaoProjeto;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoProjeto", valor: val });
      }
    },

    selecaoLinhaCreditoVM: {
      get() {
        return this.selecaoLinhaCredito;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoLinhaCredito", valor: val });
      }
    },

    selecaoModalidadeSeguroVM: {
      get() {
        return this.selecaoModalidadeSeguro;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoModalidadeSeguro", valor: val });
      }
    },

    selecaoSafraVM: {
      get() {
        return this.selecaoSafra;
      },
      set(val) {
        this.setFiltroCampo({ campo: "selecaoSafra", valor: val });
      }
    }
  },

  async created() {
    await this.buscarDados();
  },

  beforeDestroy() {
    if (this.$route.path === "/astec/projetos/lotesImportacao") {
      this.limparFiltrosProjetosLote();
    }
  },

  methods: {
    ...filtrosProjetosLoteHelper({
      state: [],
      getters: [],
      actions: ["setFiltroCampo", "limparFiltrosProjetosLote"]
    }).methods,

    ...paginacaoProjetoPorLoteHelper({
      state: [],
      getters: [],
      actions: ["resetarPaginacao"]
    }).methods,

    clicarParaFiltrar() {
      this.filtroClicadoPeloBotao = true;
      this.emitirFiltro();
    },

    async buscarDados() {
      try {
        await this.carregarDadosReais();
        await this.emitirFiltro();

        if (this.selecaoProjetoLkp.length === 0) {
          this.selecaoProjetoLkp = [
            { name: "Nenhum projeto disponível", value: null, disabled: true }
          ];
        }

        this.loading = false;
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
        this.loading = false;
      }
    },

    async carregarDadosReais() {
      try {
        if (typeof this.buscarLkpProjeto === "function") {
          const projetos = await this.buscarLkpProjeto();
          if (projetos && projetos.length > 0) {
            this.selecaoProjetoLkp = projetos;
          }
        }

        if (typeof this.buscarLkpSafra === "function") {
          const safras = await this.buscarLkpSafra();
          if (safras && safras.length > 0) {
            this.selecaoSafraLkp = safras;
          }
        }

        if (typeof this.buscarLkpLinhaCredito === "function") {
          const linhas = await this.buscarLkpLinhaCredito();
          if (linhas && linhas.length > 0) {
            this.linhaCreditoLkp = linhas;
          }
        }

        if (typeof this.buscarLkpModalidadeSeguro === "function") {
          const modalidades = await this.buscarLkpModalidadeSeguro();
          if (modalidades && modalidades.length > 0) {
            this.selecaoModalidadeSeguroLkp = modalidades;
          }
        }
      } catch (error) {
        console.log("Erro ao carregar dados:", error);
      }
    },

    async limpar() {
      this.limparFiltrosProjetosLote();
      this.emitirFiltro();
      this.$emit("limparGrid");
    },

    async emitirFiltro() {
      if (this.filtroClicadoPeloBotao) {
        await this.resetarPaginacao();
        this.filtroClicadoPeloBotao = false;
      }
      const filtro = {
        sq_astec_integracao_lote: localStorage.getItem("sqAstecIntegracaoLote")
          ? parseInt(localStorage.getItem("sqAstecIntegracaoLote"))
          : null,
        st_registro: this.selecaoStatusImportacao?.value ?? null,
        sq_tp_projeto: this.selecaoProjeto?.value ?? null,
        sq_linha_credito: this.selecaoLinhaCredito?.value ?? null,
        sq_modalidade_seguro: this.selecaoModalidadeSeguro?.value ?? null,
        cd_safra: this.selecaoSafra?.name ?? null
      };
      this.$emit("filtroPrjetosLote", filtro);

      if (this.$refs.accordionFiltroProjetosLote) {
        this.$refs.accordionFiltroProjetosLote.fechar();
      }
    },

    voltarAnterior() {
      this.$router.push("/astec/projetos/lotesImportacao");
    }
  }
};
</script>

<style lang="scss" scoped>
.row-buttons-filtro {
  z-index: 0;
}
</style>
